import ExcelJS from 'exceljs';

export function excelCellToString(cellValueRaw: ExcelJS.CellValue): string {
  if (cellValueRaw === null || cellValueRaw === undefined) return '';

  if (typeof cellValueRaw === 'number') {
    return cellValueRaw > 1e10 ? cellValueRaw.toFixed(0) : String(cellValueRaw);
  }

  if (typeof cellValueRaw === 'object') {
    if ('text' in cellValueRaw) {
      return String((cellValueRaw as { text?: string }).text || '');
    }
    if ('result' in cellValueRaw) {
      const result = (cellValueRaw as { result?: unknown }).result;
      if (typeof result === 'number') {
        return result > 1e10 ? result.toFixed(0) : String(result);
      }
      return result == null ? '' : String(result);
    }
    if (
      'toISOString' in cellValueRaw &&
      typeof (cellValueRaw as Date).toISOString === 'function'
    ) {
      return (cellValueRaw as Date).toISOString();
    }
    return String(cellValueRaw);
  }

  return String(cellValueRaw);
}
